/**
 * Oceanpayment「州代码」附录查找（国家 ISO 3166-1 alpha-2 + 州英文名 → 附录中的州代码）。
 * 数据仅来自 ./oceanpayment-state-appendix.json（可直接编辑该文件维护对照表）。
 */
import OCEAN_STATE_APPENDIX from './oceanpayment-state-appendix.json'

export { OCEAN_STATE_APPENDIX }

/**
 * @param {string} [countryAlpha2]
 * @param {string} [regionLabel] 与 ipinfo.region / 附录「州名称(英文)」一致
 * @returns {string} 提交给 Oceanpayment billing_state 的值（如 US 为 CA，非完整 ISO 3166-2）
 */
export function oceanBillingStateForRegion(countryAlpha2, regionLabel) {
  const cc = typeof countryAlpha2 === 'string' ? countryAlpha2.toUpperCase() : ''
  if (!cc) return ''
  const table = OCEAN_STATE_APPENDIX[cc]
  if (!table || typeof table !== 'object') return ''

  const region = typeof regionLabel === 'string' ? regionLabel.trim() : ''
  if (!region) return ''

  const hit = table[region]
  return typeof hit === 'string' && hit ? hit : ''
}
